(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["common-design"] && !Shopify.designMode) return;
  try {
    (() => {
    const plainTitle = value => String(value || '').replace(/&(?:amp|quot|apos|lt|gt|nbsp|#\d+|#x[\da-f]+);/gi, entity => {
      const names = {amp: '&', quot: '"', apos: "'", lt: '<', gt: '>', nbsp: '\u00a0'};
      const token = entity.slice(1, -1).toLowerCase();
      if (token[0] !== '#') return names[token] || entity;
      const point = token[1] === 'x' ? parseInt(token.slice(2), 16) : Number(token.slice(1));
      return point > 0 && point <= 0x10ffff && !(point >= 0xd800 && point <= 0xdfff) ? String.fromCodePoint(point) : entity;
    });
    const initTabs = (scope = document) => {
      scope.querySelectorAll('[data-cm-tabs]').forEach(group => {
        if (group.dataset.ready) return;
        group.dataset.ready = 'true';
        const tabs = [...group.querySelectorAll('[data-cm-tab]')];
        const panels = [...group.querySelectorAll('[data-cm-panel]')];
        if (tabs.length < 2) return;
        group.querySelector('.cm-tabs').setAttribute('role', 'tablist');
        const activate = (index, focus = false) => {
          tabs.forEach((tab, i) => {
            tab.id ||= `${panels[i].id}-tab`;
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-controls', panels[i].id);
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            tab.classList.toggle('is-active', i === index);
            panels[i].setAttribute('role', 'tabpanel');
            panels[i].setAttribute('aria-labelledby', tab.id);
            panels[i].tabIndex = 0;
            panels[i].hidden = i !== index;
          });
          if (focus) tabs[index].focus();
        };
        tabs.forEach((tab, i) => {
          tab.addEventListener('click', event => { event.preventDefault(); activate(i); });
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
            if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next !== undefined) { event.preventDefault(); activate(next, true); }
          });
        });
        group.addEventListener('shopify:block:select', event => {
          const index = panels.findIndex(panel => panel === event.target || panel.contains(event.target));
          if (index !== -1) activate(index);
        });
        activate(0);
      });
    };
    const initHeader = (scope = document) => {
      scope.querySelectorAll('[data-cm-header]').forEach(header => {
        if (header.dataset.ready) return;
        header.dataset.ready = 'true';
        let headerFrame;
        let lastHeaderSize = '';
        const measureHeader = () => {
          if (!header.isConnected) return;
          const headerHeight = header.offsetHeight;
          const groupHeight = document.querySelector('#header-group')?.offsetHeight || header.offsetHeight;
          const size = `${headerHeight}:${groupHeight}`;
          if (size === lastHeaderSize) return;
          lastHeaderSize = size;
          document.body.style.setProperty('--header-height', `${headerHeight}px`);
          document.body.style.setProperty('--header-group-height', `${groupHeight}px`);
          document.body.style.setProperty('--cm-header-height', `${groupHeight}px`);
        };
        const scheduleHeader = () => { cancelAnimationFrame(headerFrame); headerFrame = requestAnimationFrame(measureHeader); };
        const headerObserver = new ResizeObserver(scheduleHeader);
        headerObserver.observe(header);
        scheduleHeader();
        const unloadHeader = event => {
          if (event.target.contains(header)) {
            headerObserver.disconnect();
            cancelAnimationFrame(headerFrame);
            document.removeEventListener('shopify:section:unload', unloadHeader);
          }
        };
        document.addEventListener('shopify:section:unload', unloadHeader);
        const menus = [...header.querySelectorAll('.cm-mega,.cm-mobile-menu')];
        menus.forEach(menu => menu.addEventListener('toggle', () => {
          if (menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
        }));
        header.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          menus.forEach(menu => { if (menu.open) { menu.open = false; menu.querySelector('summary').focus(); } });
        });
        document.addEventListener('click', event => {
          if (!header.isConnected) return;
          menus.forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
        });
        const wrap = header.querySelector('[data-cm-search]');
        const input = wrap.querySelector('input[type="search"]');
        const results = wrap.querySelector('[data-cm-search-results]');
        let timer, controller;
        const close = () => { results.hidden = true;  };
        input.addEventListener('input', () => {
          clearTimeout(timer); controller?.abort(); close();
          const query = input.value.trim();
          if (query.length < 2) return;
          timer = setTimeout(async () => {
            controller = new AbortController();
            try {
              const url = new URL(`${results.dataset.searchUrl}.json`, location.origin);
              url.searchParams.set('q', query);
              url.searchParams.set('resources[type]', 'product');
              url.searchParams.set('resources[limit]', '5');
              const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
              if (!response.ok) return;
              const json = await response.json();
              if (input.value.trim() !== query || !wrap.contains(document.activeElement)) return;
              results.replaceChildren();
              const products = json.resources?.results?.products || [];
              products.forEach(product => {
                const link = document.createElement('a');
                const destination = new URL(product.url, location.origin);
                if (destination.origin !== location.origin) return;
                link.href = destination.href;
                if (product.image) {
                  const image = document.createElement('img');
                  const thumbnail = new URL(product.image, location.origin);
                  if (thumbnail.protocol === 'https:' || thumbnail.protocol === 'http:') {
                    thumbnail.searchParams.set('width', '90');
                    image.src = thumbnail.href;
                    thumbnail.searchParams.set('width', '135');
                    image.srcset = `${image.src} 2x, ${thumbnail.href} 3x`;
                    image.alt = ''; image.width = 45; image.height = 45; image.decoding = 'async';
                    link.append(image);
                  }
                }
                const title = document.createElement('span'); title.textContent = plainTitle(product.title); link.append(title); results.append(link);
              });
              if (!products.length) { const message = document.createElement('p'); message.textContent = results.dataset.empty; results.append(message); }
              results.hidden = false; 
            } catch (error) { if (error.name !== 'AbortError') close(); }
          }, 220);
        });
        wrap.addEventListener('keydown', event => {
          if (event.key === 'Escape') { controller?.abort(); close(); input.focus(); }
          if (event.key === 'ArrowDown' && event.target === input && !results.hidden) { event.preventDefault(); results.querySelector('a')?.focus(); }
        });
        wrap.addEventListener('focusout', () => setTimeout(() => { if (!wrap.contains(document.activeElement)) { controller?.abort(); close(); } }, 0));
      });
    };
    const initHoverImages = (scope = document) => {
      scope.querySelectorAll('[data-cm-hover-image]').forEach(template => {
        const link = template.parentElement;
        if (link.dataset.cmHoverReady) return;
        link.dataset.cmHoverReady = 'true';
        const load = () => {
          if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
          const image = template.content.querySelector('img')?.cloneNode(true);
          if (!image) return;
          link.append(image);
          template.remove();
          link.removeEventListener('pointerenter', load);
          link.removeEventListener('focusin', load);
        };
        link.addEventListener('pointerenter', load);
        link.addEventListener('focusin', load);
      });
    };
    const footerDesktop = window.matchMedia('(min-width: 750px)');
    const initFooter = (scope = document) => {
      scope.querySelectorAll('.cm-footer-column').forEach(column => {
        if (footerDesktop.matches) column.open = true;
        if (column.dataset.cmFooterReady) return;
        column.dataset.cmFooterReady = 'true';
        column.querySelector('summary')?.addEventListener('click', event => {
          if (footerDesktop.matches) { event.preventDefault(); column.open = true; }
        });
      });
    };
    footerDesktop.addEventListener('change', () => initFooter());
    const init = (scope = document) => { initTabs(scope); initHeader(scope); initFooter(scope); initHoverImages(scope); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
